import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

interface EditableReviewSectionProps {
  title: string
  onEdit?: () => void
  children: React.ReactNode
}

export const EditableReviewSection = ({
  title,
  onEdit,
  children,
}: EditableReviewSectionProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-base font-medium text-neutralColor lg:text-xl">
          {title}
        </p>
        {onEdit && (
          <Button type="button" variant="secondary" size="sm" onClick={onEdit}>
            {t('dashboard.runReport.submitReport.edit')}
          </Button>
        )}
      </div>
      {children}
    </div>
  )
}
